import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Fetch } from '../../utils/Utils.js';

const formatHerdLotId = (lotId, prefix) =>
  lotId != null ? `${prefix}-${String(lotId).padStart(4, '0')}` : '-';

export const HerdLotDropdown = ({ selected, onChange, name = 'herd_lot_id' }) => {
  const { t } = useTranslation();
  const [lots, setLots] = useState([]);

  useEffect(() => {
    Fetch('api/data/lots?search_fields=type&search_values=herd', 'get', null, (data) => {
      setLots([...(data || [])].sort((a, b) => b.lot_id - a.lot_id));
    });
  }, []);

  return (
    <select name={name} value={selected || ''} onChange={onChange}>
      <option value="">{t('select_herd_lot')}</option>
      {lots.map(lot => (
        <option key={lot._id} value={lot.lot_id}>
          {formatHerdLotId(lot.lot_id, t('herd_lot_prefix'))}{lot.name ? ` — ${lot.name}` : ''}
        </option>
      ))}
    </select>
  );
};

export default HerdLotDropdown;
